var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.973 2.678a.333.333 0 0 0-.561.108l-.738 2.042c-.18.45-.59.766-1.07.826H9.716a.333.333 0 0 0-.256.48l.589 1.516a.333.333 0 0 0 .297.184h.551a.333.333 0 0 1 .298.481l-1.847 3.786a1.348 1.348 0 0 1-2.572-.165l-.66-2.772a.333.333 0 0 0-.297-.184h-.296a2.162 2.162 0 0 1 0-4.324h2.728a.333.333 0 0 0 .332-.332V3.56a1.33 1.33 0 0 0-.831-1.233l-.19-.076a.333.333 0 0 1-.041-.598L9.33.722a.333.333 0 0 0-.1-.624A7.748 7.748 0 0 0 8.018 0a8 8 0 1 0 5.955 2.678z",
    fill: "#8B909A",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobeIcon);
export default __webpack_public_path__ + "static/media/globe-icon.75d85446653ccd405b6af2952e0ab79c.svg";
export { ForwardRef as ReactComponent };